import { Action, Dispatch } from 'redux';

import { providersActionsCreatorsTypes } from 'containers/LandingPage/store/actions/providersConfig.actions';
import API from 'helpers/api';
import { IntegrationConfigService } from 'services/IntegrationConfig.service';
import { ThunkDispatch } from 'redux-thunk';
import { PROVIDERS } from 'helpers/global.config';
import { AppStates } from 'store';

/**
 * Get all providers available for the Marketplace
 * @returns {Array} list of providers
 */
export const getProviders = () => async (dispatch: Dispatch) => {
  dispatch(providersActionsCreatorsTypes.searchProviders());
  try {
    const providers = await IntegrationConfigService.getProviders();
    dispatch(providersActionsCreatorsTypes.searchProvidersSuccess(providers));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    dispatch(providersActionsCreatorsTypes.searchProvidersError(error.message));
  }

};

export const searchProvidersConfig = () => async (dispatch: Dispatch, getState: () => AppStates) => {
  const {
    providersConfig: {
      organization: {},
    },
  } = getState();
  dispatch(providersActionsCreatorsTypes.searchProvidersConfig());
  try {
    const response = await API.get('organizations/integrationConfigs');

    const hasError = parseInt(response?.statusCode) >= 400 || 
      response?.status === 'error' || 
      response?.message === 'Not found'; // From NotFoundMiddleware in the API
    
    if (hasError) {
      dispatch(providersActionsCreatorsTypes.searchProvidersConfigError(response?.message));
    } else {
      dispatch(providersActionsCreatorsTypes.searchProvidersConfigSuccess(response));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    dispatch(providersActionsCreatorsTypes.searchProvidersConfigError(error.message));
  }
};

export const saveProviderConfig =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (newOrgConfig: any, type: any) => async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates) => {
    const {
      providersConfig: {
        organization: { orgId = '' },
      },
    } = getState();
    dispatch(providersActionsCreatorsTypes.saveProvidersConfig());
    try {
      await IntegrationConfigService.saveConfiguration(orgId, type || '', newOrgConfig);
      dispatch(providersActionsCreatorsTypes.saveProvidersConfigSuccess());
      dispatch(searchProvidersConfig());
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(providersActionsCreatorsTypes.saveProvidersConfigError(error.message));
    }
  };

export const enableProvider =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (integratorType: string) => async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates) => {
    const {
      providersConfig: {
        organization: { orgId = '' },
      },
    } = getState();
    dispatch(providersActionsCreatorsTypes.saveProvidersConfig());
    try {
      await IntegrationConfigService.enableProviderConfig(orgId, integratorType);
      dispatch(providersActionsCreatorsTypes.saveProvidersConfigSuccess());
      dispatch(searchProvidersConfig());
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(providersActionsCreatorsTypes.saveProvidersConfigError(error.message));
    }
  };

export const disableProvider =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (integratorType: string) => async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates) => {
    const {
      providersConfig: {
        organization: { orgId = '' },
      },
    } = getState();
    dispatch(providersActionsCreatorsTypes.saveProvidersConfig());
    try {
      await IntegrationConfigService.disableProviderConfig(orgId, integratorType);
      dispatch(providersActionsCreatorsTypes.saveProvidersConfigSuccess());
      dispatch(searchProvidersConfig());
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(providersActionsCreatorsTypes.saveProvidersConfigError(error.message));
    }
  };

export const disableProviderConfig =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (integratorType: string) => async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates) => {
    const {
      providersConfig: {
        organization: { orgId = '' },
      },
    } = getState();
    dispatch(providersActionsCreatorsTypes.saveProvidersConfig());
    try {
      await IntegrationConfigService.disableConfiguration(orgId, integratorType);
      dispatch(providersActionsCreatorsTypes.saveProvidersConfigSuccess());
      dispatch(searchProvidersConfig());
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(providersActionsCreatorsTypes.saveProvidersConfigError(error.message));
    }
  };
//send apiKey in order to change the env parameter
export const enableProviderConfig =
// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (integratorType: string, orgApiIdsFound: string, newOrgConfig: any) =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
      async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates): Promise<any> => {
        const {
          providersConfig: {
            organization: { orgId = '' },
          },
        } = getState();
        dispatch(providersActionsCreatorsTypes.saveProvidersConfig());
        try {
          if (orgApiIdsFound) {
            await IntegrationConfigService.enableConfiguration(
              orgId,
              integratorType || '',
              orgApiIdsFound || '', //apí key to send
            );
          }
          let response;
          switch (integratorType) {
            case PROVIDERS.square:
              window.location.href = `${import.meta.env.VITE_APPS_API_URL || ''}auth/square/login/${orgId}`;
              break;
            case PROVIDERS.airtable:
              window.location.href = `${import.meta.env.VITE_APPS_API_URL || ''}auth/airtable/login/${orgId}`;
              break;
            default:
              response = await IntegrationConfigService.loginProviderConfiguration(
                orgId,
                integratorType || '',
                newOrgConfig,
              );
              break;
          }

          dispatch(providersActionsCreatorsTypes.saveProvidersConfigSuccess());
          dispatch(searchProvidersConfig());
          return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
          dispatch(providersActionsCreatorsTypes.saveProvidersConfigError(error.message));
        }
      };

export const getOrganizationApiKey =
// eslint-disable-next-line @typescript-eslint/no-explicit-any
    () => async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates) => {
      const {
        providersConfig: {
          organization: { orgId = '' },
        },
      } = getState();    dispatch(providersActionsCreatorsTypes.searchOrganizationApikeysId());
      try {
        const response = await IntegrationConfigService.getOrganizationApiKey(orgId);
        dispatch(providersActionsCreatorsTypes.searchOrganizationAPIkeysIdSuccess(response));
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        dispatch(providersActionsCreatorsTypes.searchOrganizationAPIkeysIdError(error.message));
      }
    };

/**
 * Renews the provider token based on the integrator type.
 *
 * @param {string} integratorType - The type of integrator.
 * @returns {Promise<void>} A promise that resolves when the token renewal process is complete.
 */
export const renewProviderToken =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (integratorType: string) => async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates) => {
    const {
      providersConfig: {
        organization: { orgId = '' },
      },
    } = getState();
    dispatch(providersActionsCreatorsTypes.saveProvidersConfig());
    window.location.href = `${import.meta.env.VITE_APPS_API_URL || ''}auth/${integratorType}/login/${orgId}`;

    dispatch(providersActionsCreatorsTypes.saveProvidersConfigSuccess());
    dispatch(searchProvidersConfig());
  };

/**
 * Sets an error for the authentication process of a specific provider.
 * @param {string} provider - The provider for which to set the error.
 * @returns {Promise<void>} A promise that resolves when the error is set.
 */
export const setAuthError = (provider: string) => async (dispatch: Dispatch) => {
  dispatch(providersActionsCreatorsTypes.setAuthError(provider));
};

/**
 * Removes the authentication error.
 * @returns {Promise<void>} A promise that resolves when the authentication error is removed.
 */
export const removeAuthError = () => async (dispatch: Dispatch) => {
  dispatch(providersActionsCreatorsTypes.removeAuthError());
};

export const showSummary = () => async (dispatch: Dispatch) => {
  dispatch(providersActionsCreatorsTypes.showSummary());
};

export const hideSummary = () => async (dispatch: Dispatch) => {
  dispatch(providersActionsCreatorsTypes.hideSummary());
};

export const enableEdit = () => async (dispatch: Dispatch) => {
  dispatch(providersActionsCreatorsTypes.enableEdit());
};

export const disableEdit = () => async (dispatch: Dispatch) => {
  dispatch(providersActionsCreatorsTypes.disableEdit());
};

export const setStepId = (data: number | null) => async (dispatch: Dispatch) => {
  dispatch(providersActionsCreatorsTypes.setStepId(data));
};

/**
 * Method called to execute dispatch to delete application for provider
 * @param integratorType Name of provider
 */
export const deleteProviderData =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (integratorType: string) => async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates) => {
    const {
      providersConfig: {
        organization: { orgId = '' },
      },
    } = getState();
    dispatch(providersActionsCreatorsTypes.deleteProvidersInfo());
    try {
      await IntegrationConfigService.deleteApplication(orgId, integratorType);
      dispatch(providersActionsCreatorsTypes.deleteProvidersInfoSuccess());
      dispatch(searchProvidersConfig());
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(providersActionsCreatorsTypes.deleteProvidersInfoError(error.message));
    }
  };
  
/**
 * Retrieves Airtable bases for the organization.
 * @returns {Promise<void>} A promise that resolves when the retrieval process is complete.
 */
export const getAirtableBases =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  () => async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates) => {
    const {
      providersConfig: {
        organization: { orgId = '' },
      },
    } = getState();
    
    dispatch(providersActionsCreatorsTypes.searchAirtableBases());
    try {
      const { bases } = await IntegrationConfigService.getAirtableBases(orgId);
      dispatch(providersActionsCreatorsTypes.searchAirtableBasesSuccess(bases));
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(providersActionsCreatorsTypes.searchAirtableBasesError(error.message));
    }
  };

/**
 * Retrieves WhenIWork positions for the organization.
 * @returns {Promise<void>} A promise that resolves when the retrieval process is complete.
 */
export const getWIWPositions =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  () => async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates) => {
    const {
      providersConfig: {
        organization: { orgId = '' },
      },
    } = getState();
    
    dispatch(providersActionsCreatorsTypes.searchWIWPositions());
    try {
      const positions = await IntegrationConfigService.getWIWPositions(orgId);
      dispatch(providersActionsCreatorsTypes.searchWIWPositionsSuccess(positions));
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(providersActionsCreatorsTypes.searchWIWPositionsError(error.message));
    }
  };

/**
 * Re-syncs Onfleet workers with WhenIWork users for the organization.
 * @returns {Promise<void>} A promise that resolves when the retrieval process is complete.
 */
export const resyncWIW =
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  () => async (dispatch: ThunkDispatch<any, void, Action>, getState: () => AppStates) => {
    const {
      providersConfig: {
        organization: { orgId = '' },
      },
    } = getState();
    dispatch(providersActionsCreatorsTypes.resyncWIWUsers());
    try {
      await IntegrationConfigService.resyncWIWUsers(orgId);
      dispatch(providersActionsCreatorsTypes.resyncWIWUsersSuccess());
      dispatch(searchProvidersConfig());
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      dispatch(providersActionsCreatorsTypes.resyncWIWUsersError(error.message));
    }
  };
